import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthentication } from "./useAuthentication";

import axios from "axios";
import { useCache } from "./useCache";

const API_BASE_URL = process.env.REACT_APP_SUCCOTH_API_BASE_URL;
const ACCESS_TOKEN = process.env.REACT_APP_SUCCOTH_API_ACCESS_TOKEN;

export function useApi() {
  const navigate = useNavigate();
  const {
    user,
    authProvider: { signOut },
  } = useAuthentication();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // console.log(user)

  const createAccessHeader: any = useCallback(
    async (apiKey?: string, files = false) => {
      try {
        const token = user ? user?.auth.access_token : ACCESS_TOKEN;
        return {
          "Content-Type": files ? "multipart/form-data" : "application/json",
          Authorization: `Bearer ${token}`,
        };
      } catch (error) {
        navigate("/error");
        console.log(error);
        return null;
      }
    },
    [navigate, user]
  );

  type sendRequestProps = {
    method: string;
    url: string;
    data?: any;
    files?: boolean;
  };

  const sendRequest = useCallback(
    async ({ method, url, data, files }: sendRequestProps) => {
      return axios({
        url: url,
        method: method,
        headers: await createAccessHeader(null, files),
        data: data,
      })
        .then((response) => {
          return response.data;
        })
        .catch((error: any) => {
          console.log(user);
          if (
            error?.response?.status === 500 ||
            error.message === "Network Error" ||
            error.code === "ERR_BAD_RESPONSE"
          ) {
            navigate("/error");
            return;
          }
          if (error?.response?.status === 401) {
            // show permission screen page instead
            signOut();
            // navigate("/error");
            return;
          }
          if (error.code === "ERR_CANCELED") {
            console.log("Request timed out");
          } else {
            return error.response.data;
          }
        });
    },
    [createAccessHeader, navigate, user, signOut]
  );

  // Complaints
  const getComplaints = useCallback(
    async (page: number = 1, keyword: string = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/complaints/?page=${page}&keyword=${keyword}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Areas
  const getAreas = useCallback(
    async (page: number = 1, city = "", keyword: string = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/areas/?page=${page}&city=${city}&keyword=${keyword}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getArea = useCallback(
    async (id) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/areas/${id}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addArea = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/areas/`,
          data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateArea = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/areas/${data.id}/`,
          data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Cities
  const getCities = useCallback(
    async (countryId?: any, page: number = 1, keyword: string = "", cityId="") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/cities/?page=${page}&countryId=${countryId}&keyword=${keyword}&cityId=${cityId}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getCity = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/cities/${id}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addCity = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/cities/`,
          data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateCity = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/cities/${data.id}/`,
          data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Countries
  const getCountries = useCallback(
    async (page: number = 1, keyword: string = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/countries/?page=${page}&keyword=${keyword}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getCountry = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/countries/${id}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addCountry = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/countries/`,
          data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateCountry = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/countries/${data.id}/`,
          data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const uploadCompanyLogo = useCallback(
    async (data: any, company_id: number) => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/companies/logo/upload/${company_id}/`,
          {
            method: "post",
            body: data,
            headers: {
              Authorization: `Bearer ${
                user ? user?.auth.access_token : ACCESS_TOKEN
              }`,
            },
          }
        );
        setIsLoading(false);
        return response.json();
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [user]
  );
  const uploadCompanyBanner = useCallback(
    async (data: any, company_id: number) => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/companies/banner/upload/${company_id}/`,
          {
            method: "post",
            body: data,
            headers: {
              Authorization: `Bearer ${
                user ? user?.auth.access_token : ACCESS_TOKEN
              }`,
            },
          }
        );
        setIsLoading(false);
        return response.json();
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [user]
  );
  const uploadCompanyRepPhoto = useCallback(
    async (data: any, company_id: number) => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/companies/rep-image/upload/${company_id}/`,
          {
            method: "post",
            body: data,
            headers: {
              Authorization: `Bearer ${
                user ? user?.auth.access_token : ACCESS_TOKEN
              }`,
            },
          }
        );
        setIsLoading(false);
        return response.json();
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [user]
  );

  // QrCode
  const getQrCodes = useCallback(
    async (page: number = 1, requestId: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/qr-codes/?page=${page}&request_id=${requestId}`,
        });
        setIsLoading(false);
        // setRoomCategories(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const updateQrCode = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/qr-codes/${data.id}/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const generateQrCodes = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/qr-codes/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const scanQrCodes = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/qr-codes/${data.verification_token}/scan`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // QrCode Requests
  const getQrCodeRequests = useCallback(
    async (
      page: number = 1,
      keyword: string = "",
      startDate = "",
      endDate = ""
    ) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/qrcode-request/?page=${page}&keyword=${keyword}&start_date=${startDate}&end_date=${endDate}`,
        });
        setIsLoading(false);
        // setRoomCategories(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getQrCodeRequest = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/qrcode-request/${id}`,
        });
        setIsLoading(false);
        // setRoomCategories(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addQrCodeRequest = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/qrcode-request/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateQrCodeRequest = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/qrcode-request/${data.id}/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Documents
  const getDocuments = useCallback(async () => {
    try {
      const result = await sendRequest({
        method: "get",
        url: `${API_BASE_URL}/documents/`,
      });
      setIsLoading(false);
      return result;
    } catch (err) {
      setIsLoading(false);
      console.log("ERRORRRRR", err);
      return [];
    }
  }, [sendRequest]);

  const getDocument = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/documents/${id}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  const addDocument = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/documents/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateDocument = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/documents/${data.get("id")}/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const uploadRoomImage = useCallback(
    async (data: any, room_id: number) => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/rooms/image/upload/${room_id}/`,
          {
            method: "post",
            body: data,
            headers: {
              Authorization: `Bearer ${
                user ? user?.auth.access_token : ACCESS_TOKEN
              }`,
            },
          }
        );
        setIsLoading(false);
        return response.json();
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [user]
  );

  // Companies
  const getCompanies = useCallback(
    async (
      page: number = 1,
      keyword: string = "",
      startDate = "",
      endDate = ""
    ) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/companies/?page=${page}&keyword=${keyword}&start_date=${startDate}&end_date=${endDate}`,
        });
        setIsLoading(false);
        // setBookings(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getCompany = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/companies/${id}`,
        });
        setIsLoading(false);
        // setBookings(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const checkInBooking = useCallback(
    async (token: string) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/check-in/bookings/`,
          data: { token: token },
        });
        setIsLoading(false);
        const rsp = await result;
        return rsp;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const updateCompany = useCallback(
    async (data: any, files: boolean = true) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/companies/${data.id}/`,
          data: data,
          files: false,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const addCompany = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/companies/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // user profile
  const getUserProfile = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/users/profile/${id}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  const updateUserProfile = useCallback(
    async (data: FormData) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/users/profile/${data.get("id")}/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Users
  const getUsers = useCallback(
    async (page: number = 1, keyword: string = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/system-users/?page=${page}&keyword=${keyword}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  const getUser = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/system-users/${id}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  const addUser = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/system-users/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateUser = useCallback(
    async (data: FormData) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/system-users/${data.get("id")}/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const toggleUserActive = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/system-users/${data.id}/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Dealers
  const getDealers = useCallback(
    async (page = 1, keyword: string = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/dealers/?page=${page}&keyword=${keyword}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  const getDealer = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/dealers/${id}`,
        });
        setIsLoading(false);
        // setBookings(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addDealer = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/dealers/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateDealer = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/dealers/${data.get("id")}/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const uploadDealerProfilePicture = useCallback(
    async (data: any, dealer_id: number) => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/dealers/image/upload/${dealer_id}/`,
          {
            method: "post",
            body: data,
            headers: {
              Authorization: `Bearer ${
                user ? user?.auth.access_token : ACCESS_TOKEN
              }`,
            },
          }
        );
        setIsLoading(false);
        return response.json();
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [user]
  );

  // Dashboard
  const getDashboard = useCallback(
    async ({ startDate = "", endDate = "" }: any) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/dashboard/?start_date=${startDate}&end_date=${endDate}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  // Report
  const getReport = useCallback(
    async ({ startDate = "", endDate = "" }: any) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/reports/?start_date=${startDate}&end_date=${endDate}`,
        });
        setIsLoading(false);
        // setReport(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  const generateReportCSV = useCallback(
    async ({ startDate = "", endDate = "" }: any) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/reports/generate-report/?start_date=${startDate}&end_date=${endDate}`,
        });
        setIsLoading(false);
        // setReport(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  // Report
  const getLogs = useCallback(
    async ({
      page = 1,
      startDate = "",
      endDate = "",
      category = "",
      company = "",
    }: any) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/logs/?page=${page}&start_date=${startDate}&end_date=${endDate}&company_id=${company}&category_id=${category}`,
        });
        setIsLoading(false);
        // setReport(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  const generateLogReportCSV = useCallback(
    async ({ startDate = "", endDate = "" }: any) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/logs/download/?start_date=${startDate}&end_date=${endDate}`,
        });
        setIsLoading(false);
        // setReport(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  // Categories
  const getCategories = useCallback(
    async (page: number = 1, keyword: string = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/categories/?page=${page}&keyword=${keyword}`,
        });
        setIsLoading(false);
        // setCategories(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getCategory = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/categories/${id}`,
        });
        setIsLoading(false);
        // setCategories(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addCategory = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/categories/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const updateCategory = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/categories/${data.id}/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Products
  const getProducts = useCallback(
    async (
      page: number = 1,
      keyword: string = "",
      companyId = "",
      categoryId = "",
      startDate = "",
      endDate = "",
      hasRequested = ""
    ) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/products/?page=${page}&keyword=${keyword}&company_id=${companyId}&category_id=${categoryId}&start_date=${startDate}&end_date=${endDate}&has_requested=${hasRequested}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const uploadProductImage = useCallback(
    async (data: any, product_id: number) => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/products/image/upload/${product_id}/`,
          {
            method: "post",
            body: data,
            headers: {
              Authorization: `Bearer ${
                user ? user?.auth.access_token : ACCESS_TOKEN
              }`,
            },
          }
        );
        setIsLoading(false);
        return response.json();
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [user]
  );

  const getProduct = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/products/${id}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addProduct = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/products/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const updateProduct = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/products/${data.id}/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteProduct = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/products/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteMember = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/members/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteQrCodeRequest = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/qrcode-request/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteCompany = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/companies/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteCategory = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/categories/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteDealer = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/dealers/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteUser = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/system-users/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteArea = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/areas/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteCity = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/cities/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteSubCategory = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/sub-categories/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteComplaint = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/complaints/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteQrCode = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/qr-codes/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteRole = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/roles/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deletePermission = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/permissions/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteCountry = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/countries/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteLog = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/logs/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteInstitution = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/tax/institutions/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteSubArea = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/tax/sub-areas/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteTaxPayer = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/tax/tax-payers/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deletePenalty = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/tax/penalties/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteRefund = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/tax/refunds/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteTaxAssessment = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/tax/tax-assessments/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteTaxCollector = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/tax/tax-collectors/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteTaxSupervisor = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/tax/tax-supervisors/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteTaxLog = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/tax/logs/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteTaxPayment = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/tax/payments/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteTaxFrequency = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/tax/tax-frequencies/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const deleteTaxNature = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "delete",
          url: `${API_BASE_URL}/tax/tax-natures/${id}/`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Members
  const getMembers = useCallback(
    async (
      page: number = 1,
      keyword: string = "",
      companyId = "",
      categoryId = "",
      startDate = "",
      endDate = "",
      hasRequested = ""
    ) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/members/?page=${page}&keyword=${keyword}&company_id=${companyId}&category_id=${categoryId}&start_date=${startDate}&end_date=${endDate}&has_requested=${hasRequested}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const uploadMemberCSV = useCallback(
    async (data: any) => {
      try {
        const response = await fetch(`${API_BASE_URL}/members/csv/upload/`, {
          method: "post",
          body: data,
          headers: {
            Authorization: `Bearer ${
              user ? user?.auth.access_token : ACCESS_TOKEN
            }`,
          },
        });
        setIsLoading(false);
        return response.json();
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [user]
  );

  const getMember = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/members/${id}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Sub Category
  const getSubCategories = useCallback(
    async (page: number = 1, keyword: string = "", document: string = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/sub-categories/?page=${page}&keyword=${keyword}&document=${document}`,
        });
        setIsLoading(false);
        // setHotelManagers(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getSubCategory = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/sub-categories/${id}`,
        });
        setIsLoading(false);
        // setHotelManagers(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addSubCategory = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/sub-categories/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const updateSubCategory = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/sub-categories/${data.id}/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Permission
  const getPermissions = useCallback(
    async (page: number = 1, keyword: string = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/permissions/?page=${page}&keyword=${keyword}`,
        });
        setIsLoading(false);
        // setHotelManagers(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getPermission = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/permissions/${id}`,
        });
        setIsLoading(false);
        // setHotelManagers(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Role
  const getRoles = useCallback(
    async (page: number = 1, keyword: string = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/roles/?page=${page}&keyword=${keyword}`,
        });
        setIsLoading(false);
        // setHotelManagers(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getRole = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/roles/${id}`,
        });
        setIsLoading(false);
        // setHotelManagers(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addRole = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/roles/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const updateRole = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/roles/${data.id}/`,
          data: data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // TAX

  // Tax Payers
  const getTaxPayers = useCallback(
    async (page = 1, keyword: string = "", pageSize=50, status="", institution="", city="", subArea="", taxNature="", filterBy="", orderBy="", orderSort="", startDate = "", endDate = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-payers/?page=${page}&keyword=${keyword}&page_size=${pageSize}&status=${status}&institution=${institution}&city=${city}&sub_area=${subArea}&tax_nature=${taxNature}&filter_by=${filterBy}&order_by=${orderBy}&order_sort=${orderSort}&start_date=${startDate}&end_date=${endDate}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  const getTaxPayer = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-payers/${id}`,
        });
        setIsLoading(false);
        // setBookings(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addTaxPayer = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/tax/tax-payers/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const uploadTaxPayersData = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/tax/tax-payers/upload/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateTaxPayer = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/tax/tax-payers/${data.get("id")}/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Tax Collectors
  const getTaxCollectors = useCallback(
    async (page = 1, keyword: string = "", pageSize=50, status="",startDate = "", endDate = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-collectors/?page=${page}&keyword=${keyword}&page_size=${pageSize}&status=${status}&start_date=${startDate}&end_date=${endDate}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  const getTaxCollector = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-collectors/${id}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addTaxCollector = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/tax/tax-collectors/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateTaxCollector = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/tax/tax-collectors/${data.get("id")}/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Tax Supervisors
  const getTaxSupervisors = useCallback(
    async (page = 1, keyword: string = "",startDate = "", endDate = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-supervisors/?page=${page}&keyword=${keyword}&start_date=${startDate}&end_date=${endDate}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  const getTaxSupervisor = useCallback(
    async (id: number) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-supervisors/${id}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addTaxSupervisor = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/tax/tax-supervisors/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateTaxSupervisor = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/tax/tax-supervisors/${data.get("id")}/`,
          data: data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Areas
  const getSubAreas = useCallback(
    async (page: number = 1, area = "", keyword: string = "", institution: string="") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/sub-areas/?page=${page}&area=${area}&keyword=${keyword}&institution=${institution}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getSubArea = useCallback(
    async (id) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/sub-areas/${id}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addSubArea = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/tax/sub-areas/`,
          data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateSubArea = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/tax/sub-areas/${data.id}/`,
          data,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Tax Assessments
  const getTaxAssessments = useCallback(
    async (page: number = 1, area = "", keyword: string = "", pageSize=50, institution="", city="", subArea="", filterBy="", orderBy="", orderSort="", startDate="", endDate="", taxNature="") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-assessments/?page=${page}&area=${area}&keyword=${keyword}&page_size=${pageSize}&institution=${institution}&city=${city}&subArea=${subArea}&filter_by=${filterBy}&order_by=${orderBy}&order_sort=${orderSort}&start_date=${startDate}&end_date=${endDate}&tax_nature=${taxNature}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getTaxAssessment = useCallback(
    async (id) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-assessments/${id}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addTaxAssessment = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/tax/tax-assessments/?created_by_admin=true`,
          data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateTaxAssessment = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/tax/tax-assessments/${data.get("id")}/`,
          data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );



  // Institutions
  const getInstitutions = useCallback(
    async (page: number = 1, institution: any = "", keyword: string = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/institutions/?page=${page}&keyword=${keyword}&institutionId=${institution}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getInstitution = useCallback(
    async (id) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/institutions/${id}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addInstitution = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/tax/institutions/`,
          data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        return null;
      }
    },
    [sendRequest]
  );
  const updateInstitution = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/tax/institutions/${data.get("id")}/`,
          data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Tax Frequencies
  const getTaxFrequencies = useCallback(
    async (page: number = 1, keyword: string = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-frequencies/?page=${page}&keyword=${keyword}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getTaxFrequency = useCallback(
    async (id) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-frequencies/${id}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addTaxFrequency = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/tax/tax-frequencies/`,
          data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateTaxFrequency = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/tax/tax-frequencies/${data.id}/`,
          data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Tax Types
  const getTaxTypes = useCallback(
    async (page: number = 1, keyword: string = "") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-types/?page=${page}&keyword=${keyword}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getTaxType = useCallback(
    async (id) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-types/${id}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addTaxType = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/tax/tax-types/`,
          data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateTaxType = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/tax/tax-types/${data.get("id")}/`,
          data,
          files: true,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Tax Natures
  const getTaxNatures = useCallback(
    async (page: number = 1, keyword: string = "", institution="", subArea="") => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-natures/?page=${page}&keyword=${keyword}&institution=${institution}&subArea=${subArea}`,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const getTaxNature = useCallback(
    async (id) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/tax-natures/${id}`,
        });
        setIsLoading(false);
        // setCountries(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const addTaxNature = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/tax/tax-natures/`,
          data,
          files: false,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const updateTaxNature = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          method: "put",
          url: `${API_BASE_URL}/tax/tax-natures/${data.id}/`,
          data,
          files: false,
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );


  // payment
  const verifyPayment = useCallback(
    async (data: any) => {
      try {
        const result = await sendRequest({
          url: `${API_BASE_URL}/tax/payments/verify/`,
          data,
          method: "post",
        });
        return result;
      } catch (err) {
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );
  const getTransactions = useCallback(
    async (page: any=1, keyword:string="", pageSize=20, startDate="", endDate="", institution="", taxNature="") => {
      try {
        const result = await sendRequest({
          url: `${API_BASE_URL}/tax/payments/?page=${page}&keyword=${keyword}&page_size=${pageSize}&startDate=${startDate}&endDate=${endDate}&institution=${institution}&taxNature=${taxNature}`,
          method: "get",
        });
        return result;
      } catch (err) {
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  // Tax Report
  const getTaxReports = useCallback(
    async ({ startDate = "", endDate = "" }: any) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/reports/?start_date=${startDate}&end_date=${endDate}`,
        });
        setIsLoading(false);
        // setReport(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  // Tax Report
  const getTaxLogs = useCallback(
    async ({
      page = 1,
      startDate = "",
      endDate = "",
      category = "",
      institution = "",
      taxNature = "",
    }: any) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/logs/?page=${page}&start_date=${startDate}&end_date=${endDate}&institution_id=${institution}&category_id=${category}&tax_nature=${taxNature}`,
        });
        setIsLoading(false);
        // setReport(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  const generateTaxLogReportCSV = useCallback(
    async ({ startDate = "", endDate = "", institutionId="" }: any) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/logs/download/?start_date=${startDate}&end_date=${endDate}&institution_id=${institutionId}`,
        });
        setIsLoading(false);
        // setReport(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  const getTaxUploadData = useCallback(
    async ({page=1, institution=""}) => {
      try {
        const result = await sendRequest({
          method: "get",
          url: `${API_BASE_URL}/tax/data-uploads/?page=${page}&institution=${institution}`,
        });
        setIsLoading(false);
        // setReport(await result);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return [];
      }
    },
    [sendRequest]
  );

  // Fonction pour changer le mot de passe lors de la première connexion
  const changePasswordFirstLogin = useCallback(
    async (password: string, passwordConfirmation: string) => {
      try {
        const result = await sendRequest({
          method: "post",
          url: `${API_BASE_URL}/users/change-password-first-login/`,
          data: { password, password_confirmation: passwordConfirmation },
        });
        setIsLoading(false);
        return result;
      } catch (err) {
        setIsLoading(false);
        console.log("ERRORRRRR", err);
        return null;
      }
    },
    [sendRequest]
  );

  const { data: countries, isLoading: isCountryLoading } = useCache(
    "countries",
    getCountries
  );

  return {
    uploadCompanyBanner,
    uploadCompanyLogo,
    uploadCompanyRepPhoto,
    isLoading,
    scanQrCodes,
    getQrCodes,
    generateQrCodes,
    updateQrCode,
    getQrCodeRequests,
    getQrCodeRequest,
    updateQrCodeRequest,
    addQrCodeRequest,
    addDocument,
    updateDocument,
    getDocuments,
    getDocument,
    uploadRoomImage,
    getCompanies,
    getCompany,
    checkInBooking,
    updateCompany,
    addCompany,
    getUsers,
    getUser,
    addUser,
    updateUser,
    toggleUserActive,
    getUserProfile,
    updateUserProfile,
    getSubCategories,
    getSubCategory,
    updateSubCategory,
    addSubCategory,
    addCategory,
    getCategories,
    getCategory,
    updateCategory,
    uploadProductImage,
    addProduct,
    updateProduct,
    deleteProduct,
    deleteMember,
    deleteQrCodeRequest,
    deleteCompany,
    deleteCategory,
    deleteDealer,
    deleteUser,
    deleteArea,
    deleteCity,
    deleteSubCategory,
    deleteComplaint,
    deleteQrCode,
    deleteRole,
    deletePermission,
    deleteCountry,
    deleteLog,
    deleteInstitution,
    deleteSubArea,
    deleteTaxPayer,
    deletePenalty,
    deleteRefund,
    deleteTaxAssessment,
    deleteTaxCollector,
    deleteTaxSupervisor,
    deleteTaxLog,
    deleteTaxPayment,
    deleteTaxFrequency,
    deleteTaxNature,
    getProducts,
    getProduct,
    getDashboard,
    getReport,
    generateReportCSV,
    getDealers,
    getDealer,
    addDealer,
    updateDealer,
    uploadDealerProfilePicture,
    countries,
    isCountryLoading,
    getCountry,
    getCountries,
    addCountry,
    updateCountry,
    getCities,
    getCity,
    addCity,
    updateCity,
    getAreas,
    getArea,
    addArea,
    updateArea,
    getPermissions,
    getPermission,
    getRoles,
    getRole,
    updateRole,
    addRole,
    getComplaints,
    getLogs,
    generateLogReportCSV,
    getMember,
    getMembers,
    uploadMemberCSV,

    // TAX
    getTaxPayers,
    getTaxPayer,
    addTaxPayer,
    updateTaxPayer,
    getSubAreas,
    getSubArea,
    addSubArea,
    updateSubArea,
    getTaxCollectors,
    getTaxCollector,
    addTaxCollector,
    updateTaxCollector,
    getTaxSupervisors,
    getTaxSupervisor,
    addTaxSupervisor,
    updateTaxSupervisor,
    getTaxAssessments,
    getTaxAssessment,
    addTaxAssessment,
    updateTaxAssessment,
    getInstitution,
    getInstitutions,
    addInstitution,
    updateInstitution,
    getTaxFrequencies,
    getTaxFrequency,
    addTaxFrequency,
    updateTaxFrequency,
    getTaxTypes,
    getTaxType,
    addTaxType,
    updateTaxType,
    verifyPayment,
    getTransactions,
    getTaxNature,
    getTaxNatures,
    addTaxNature,
    updateTaxNature,
    uploadTaxPayersData,
    getTaxReports,
    getTaxLogs,
    generateTaxLogReportCSV,
    getTaxUploadData,
    changePasswordFirstLogin,
  };
}
